import { QUICK_ENTRY_SELECTION_KEYS } from 'features/quick-entry/constants';

export const buildFormParams = formData => ({
  candidateName: formData?.name || '',
  files:
    Array.isArray(formData?.files) &&
    formData?.files.map(file => ({ typeId: file?.file_type_id, url: file?.url })),
  notes: formData?.notes || null,
  typeId: QUICK_ENTRY_SELECTION_KEYS.candidate
});
